import { sendEmailValidatationCode, userEmailValidate, userLogin, userResetPassword } from "../services/userService";
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { validateLoginScreen } from "../services/validate-login";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { validateCode } from "../services/endpointUrl";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [email, setEmail] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [error, setError] = useState("");
  const [forgotOpen, setForgotOpen] = useState(false);
  const [codeOpen, setCodeOpen] = useState(false);
  const [codeOpen2, setCodeOpen2] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  useEffect(() => {
    validateLoginScreen(navigate);
  }, []);
  
  const handleProceed = () => {
    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setError("");
    forgotPasswordStep3(); // pass password safely
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      console.log('Form submitted:', form);
      const result = await userLogin(form);

      // Check if login is successful
      if (result.success) {
        localStorage.setItem("role", result.message.role);
        localStorage.setItem("customer_id", result.message.customer_id);
        localStorage.setItem("user", result.message.user);
        localStorage.setItem("user_photo", result.message.user_photo);
        localStorage.setItem("access_token", result.message.access_token);
        window.location.reload();
      } else {
        alert("Login failed: Invalid email or password.");
      }
    } catch (error: any) {
      console.error('Login failed:', error);
      const message =
        error?.response?.data?.message || "Login failed: Invalid email or password.";
      alert(message);
    }
  };

  const forgotPassword = async () => {
    setForgotOpen(false)
    setLoading(true);
    try {
      var data = {
          "email": email,
          "newuser": false
      } 
      console.log('Form submitted:', data);
      const result = await sendEmailValidatationCode(data);
      if(result.success){
        setLoading(false);
        setCodeOpen(true)
      } else {
        alert(result.message);
      }
    } catch (error: any) {
      setLoading(false);
      console.error('forgot password failed:', error);
      const message =
        error?.response?.data?.message || "error in API calling.";
      alert(message);
    }
    setLoading(false);
  }

  const forgotPasswordStep2 = async () => {
    setCodeOpen(false)
    setLoading(true)
    try {
      var data = {
          "email": email,
          "code": otp,
          "new_user": false
      } 
      const result = await userEmailValidate(data);
      if(result.success){
        setCodeOpen2(true)
        setLoading(false)
      } else {
        alert(result.message);
        setCodeOpen(true)
      }
    } catch (error: any) {
      setLoading(false)
      console.error('forgot password failed:', error);
      const message =
        error?.response?.data?.message || "error in API calling.";
      alert(message);
    }
    setLoading(false)
  }

  const forgotPasswordStep3 = async () => {
    setCodeOpen2(false)
    setLoading(true)
    try {
      var data = {
          "email": email,
          "password": password,
          "secret_key": "secret_key"
      } 
      const result = await userResetPassword(data);
      if(result.success){
        setLoading(false)
        alert("Password changed successfully");
      } else {
        setCodeOpen2(true)
        alert(result.message);
      }
    } catch (error: any) {
      setLoading(false)
      console.error('forgot password failed:', error);
      const message =
        error?.response?.data?.message || "error in API calling.";
      alert(message);
    }
    setLoading(false)
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            alt="MIRO Labs Pvt. Ltd."
            src="logo_with_name.png?color=indigo&shade=600"
            className="mx-auto h-10 w-auto"
          />
          <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                  Password
                </label>
                <div className="text-sm">
                  <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500"
                  onClick={() => setForgotOpen(true)}>
                    Forgot password?
                  </a>
                </div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  autoComplete="current-password"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            Not a member?{' '}
            <a href="register" className="font-semibold text-indigo-600 hover:text-indigo-500">
              Register
            </a>
          </p>
        </div>
      </div>
      <Dialog open={forgotOpen} onClose={() => setForgotOpen(false)} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-black/30" />

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="w-full max-w-sm rounded bg-white p-6 shadow-xl">
            <Dialog.Title className="text-lg font-semibold">Forgot Password</Dialog.Title>
            <p className="mt-2 text-sm text-gray-600">Eneter email to sent reset code at yours email</p>
            <div className="col-span-full">
              <label htmlFor="name" className="block text-sm/6 font-medium text-gray-900">
                Email
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  placeholder="Enter person name"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setForgotOpen(false)}
                className="rounded-md bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  forgotPassword()
                  // perform your action here
                }}
                className="rounded-md bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-500"
              >
                Procced
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>

      <Dialog open={codeOpen} onClose={() => setCodeOpen(false)} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-black/30" />

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="w-full max-w-sm rounded bg-white p-6 shadow-xl">
            <Dialog.Title className="text-lg font-semibold">Forgot Password</Dialog.Title>
            <p className="mt-2 text-sm text-gray-600">Eneter OTP sent at yours email</p>
            <div className="col-span-full">
              <label htmlFor="name" className="block text-sm/6 font-medium text-gray-900">
                Email OTP
              </label>
              <div className="mt-2">
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  autoComplete="otp"
                  placeholder="Enter Email OTP"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setCodeOpen(false)}
                className="rounded-md bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  forgotPasswordStep2()
                  // perform your action here
                }}
                className="rounded-md bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-500"
              >
                Procced
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
      <Dialog open={codeOpen2} onClose={() => setCodeOpen2(false)} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="w-full max-w-sm rounded bg-white p-6 shadow-xl">
            <Dialog.Title className="text-lg font-semibold">Forgot Password</Dialog.Title>
            <p className="mt-2 text-sm text-gray-600">Enter your new password</p>

            {/* New Password */}
          <div className="col-span-full mt-4">
            <label className="block text-sm font-medium text-gray-900">New Password</label>
            <div className="mt-2 relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                className="block w-full rounded-md bg-white px-3 py-1.5 pr-10 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="col-span-full mt-4">
            <label className="block text-sm font-medium text-gray-900">Retype Password</label>
            <div className="mt-2 relative">
              <input
                type={showConfirm ? "text" : "password"}
                placeholder="Re-enter new password"
                className="block w-full rounded-md bg-white px-3 py-1.5 pr-10 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowConfirm(!showConfirm)}
                className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
              >
                {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

            {/* Error Message */}
            {error && <p className="mt-2 text-sm text-red-600">{error}</p>}

            {/* Buttons */}
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setCodeOpen2(false)}
                className="rounded-md bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleProceed}
                className="rounded-md bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-500"
              >
                Proceed
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="flex flex-col items-center gap-4">
            <svg
              className="animate-spin h-10 w-10 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
            <span className="text-white text-sm">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
}
